import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../store/index.ts";
import { API_CASINO } from "../../api/casino";
import { BONUS_PROVIDER_NAME, LIVE_PROVIDER_NAME } from "../../store/enums";
import {
  capitalizeWord,
  getUrlProviderHover,
  getUrlProviderLogo,
  getUrlProviders
} from "../../utils/utils";
import { setBonusProvider, setIdProvidersLiveGame, setProviders } from "../../store/gamesSlice";

export default function useProviders() {
  const dispatch = useDispatch();
  const collectionId = useAppSelector((state) => state.common.collectionId);
  const collections = useAppSelector((state) => state.common.collectionList);
  const currency = useAppSelector((state) => state.user.currency);
  const mergeProvider = collections[collectionId]?.mergeProvider;

  const getProviders = (collectionId, currency) => {
    API_CASINO.list
      .providers(collectionId, currency)
      .then((e) => {
        const list = e.data.list;
        let bonusProvider = null;
        let idProvidersLiveGame = [];

        const providers = [];
        const length = list.length;
        const providerCusNames = list.map((el) => el.providerName).map((el) => capitalizeWord(el));
        const providerDouble = providerCusNames.filter(
          (el, index) => providerCusNames.indexOf(el) !== index
        );

        for (let i = 0; i < length; i++) {
          const provider = list[i];
          const id = provider.providerId;
          const providerName = provider.provider || "";
          const providerCusName = capitalizeWord(provider.providerName) || "";
          const providerLabel = provider.label || "";

          if (!providerName) continue;

          if (BONUS_PROVIDER_NAME === providerName) bonusProvider = { id, ...provider };
          if (LIVE_PROVIDER_NAME.includes(providerName)) idProvidersLiveGame.push(id);

          const isDouble = providerDouble.includes(providerCusName);
          const displayName =
            isDouble && providerLabel && !mergeProvider
              ? `${providerCusName} (${providerLabel})`
              : providerCusName;

          const url = mergeProvider
            ? `/games/provider/${providerCusName}`
            : `/games/provider/${providerCusName}_${id}`;

          // объединение провайдеров
          if (isDouble && mergeProvider) {
            const currentProvider = providers.find((el) => el.cusName == providerCusName);

            if (currentProvider) {
              currentProvider.gameCount += provider.gameCount;
              if (currentProvider.id) {
                currentProvider.idList = [currentProvider.id];
                delete currentProvider.id;
              }
              if (currentProvider.source) {
                currentProvider.sourceList = [currentProvider.source];
                delete currentProvider.source;
              }
              currentProvider.idList.push(id);
              currentProvider.sourceList.push(provider.source);
              continue;
            }
          }

          providers.push({
            id: id,
            displayName: displayName,
            name: providerName,
            cusName: providerCusName,
            source: provider.source,
            label: provider.label,
            gameCount: provider.gameCount,
            image: getUrlProviders(providerName),
            imageHover: getUrlProviderHover(providerName),
            url: url,
            logo: getUrlProviderLogo(providerName)
          });
        }

        providers.sort((l, r) => l.cusName?.localeCompare(r.cusName));

        dispatch(setProviders(providers));
        dispatch(setBonusProvider(bonusProvider));
        dispatch(setIdProvidersLiveGame(idProvidersLiveGame));
      })
      .catch(console.log);
  };

  useEffect(() => {
    if (!collectionId) return;
    if (!currency) return;
    getProviders(collectionId, currency);
  }, [collectionId, currency]);
}
